import React from "react";
import styles from "./centromedicodonavitta_.module.scss";

import logoImg from "./src/logo.png";
import whatsappImg from "./src/whatsapp.png";
import siteImg from "./src/site.png";
import mapsImg from "./src/maps.png";
import instagramImg from "./src/instagram.png";
import servicosImg from "./src/servicos.png";
import missaoImg from "./src/missao.png";
import { Link } from "react-router-dom";

const Centromedicodonavitta_: React.FC = () => {
    const items = [
        { img: whatsappImg, text: "WHATSAPP", borderLeft: true, borderRight: false, link: "https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de agendar uma consulta na Dona Vitta", router: false },
        { img: siteImg, text: "SITE", borderLeft: true, borderRight: true, link: "https://donavitta.com.br", router: false },
        { img: mapsImg, text: "LOCALIZAÇÃO", borderLeft: false, borderRight: true, link: "https://maps.app.goo.gl/i5ygw1tv3QZEUeq88", router: false },
        { img: instagramImg, text: "INSTAGRAM", borderLeft: true, borderRight: false, link: "https://www.instagram.com/centromedicodonavitta_?igsh=Y2t6Z2hseWVpZDQ1", router: false },
        { img: servicosImg, text: "SERVIÇOS", borderLeft: true, borderRight: true, link: "/centromedicodonavitta_/servicos", router: true },
        { img: missaoImg, text: "MISSÃO E PROPÓSITOS", borderLeft: false, borderRight: true, link: "/centromedicodonavitta_/missao", router: true },
    ];

    return (
        <div className={styles.centromedicodonavitta_}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img src={logoImg} alt="Logo Dona Vitta" className={styles.logo} />
                </div>
                <div className={styles.body}>
                    <div className={styles.grid}>
                        {items.map((item, index) => (
                            item.router ?
                                (item.borderLeft && item.borderRight) ?
                                    <Link to={item.link}>
                                        <div key={index} className={styles.card} style={{ borderLeft: "1px solid #8f6a58", borderRight: "1px solid #8f6a58" }}>
                                            <img src={item.img} alt={item.text} />
                                            <p>{item.text}</p>
                                        </div>
                                    </Link>
                                    :
                                    item.borderLeft ?
                                        <Link to={item.link}>
                                            <div key={index} className={styles.card} style={{ borderLeft: "1px solid #8f6a58" }}>
                                                <img src={item.img} alt={item.text} />
                                                <p>{item.text}</p>
                                            </div>
                                        </Link>
                                        :
                                        item.borderRight ?
                                            <Link to={item.link}>
                                                <div key={index} className={styles.card} style={{ borderRight: "1px solid #8f6a58" }}>
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </Link>
                                            :
                                            <Link to={item.link}>
                                                <div key={index} className={styles.card} >
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </Link>
                                :
                                (item.borderLeft && item.borderRight) ?
                                    <a href={item.link} target="_blank">
                                        <div key={index} className={styles.card} style={{ borderLeft: "1px solid #8f6a58", borderRight: "1px solid #8f6a58" }}>
                                            <img src={item.img} alt={item.text} />
                                            <p>{item.text}</p>
                                        </div>
                                    </a>
                                    :
                                    item.borderLeft ?
                                        <a href={item.link} target="_blank">
                                            <div key={index} className={styles.card} style={{ borderLeft: "1px solid #8f6a58" }}>
                                                <img src={item.img} alt={item.text} />
                                                <p>{item.text}</p>
                                            </div>
                                        </a>
                                        :
                                        item.borderRight ?
                                            <a href={item.link} target="_blank">
                                                <div key={index} className={styles.card} style={{ borderRight: "1px solid #8f6a58" }}>
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </a>
                                            :
                                            <a href={item.link} target="_blank">
                                                <div key={index} className={styles.card} >
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </a>

                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Centromedicodonavitta_;
